var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.error)?_c('div',{staticClass:"organization"},[(!_vm.name)?_c('b-spinner',{attrs:{"variant":"white","type":"grow"}}):_c('span',{staticClass:"org"},[_vm._v(_vm._s(_vm.name))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }